{
  "id": "kite-r2-tarmac",
  "name": "Arden Kite R2 (tarmac test set-up)",
  "description": "Hidden test car: same car with a tarmac set-up: 18-inch tarmac tyres, lower ride height, stiffer springs, longer final drive.",
  "model": "../kite-r2/model.glb",
  "sources": [
    {
      "claim": "Tarmac set-up: 235/40 R18 tyres, ~202 km/h top speed, 2.2-2.3 Hz ride",
      "derived": "see kite-r2 sources; final drive 3.90 gives ~202 km/h at 7,500 rpm"
    }
  ],
  "chassis": {
    "mass": 1390,
    "inertia": [
      1950,
      2050,
      520
    ],
    "centerOfMass": [
      0,
      0.44,
      0.23
    ],
    "hull": [
      [
        0.88,
        0.3,
        2.02
      ],
      [
        -0.88,
        0.3,
        2.02
      ],
      [
        0.88,
        0.3,
        -1.98
      ],
      [
        -0.88,
        0.3,
        -1.98
      ],
      [
        0.91,
        0.62,
        2.06
      ],
      [
        -0.91,
        0.62,
        2.06
      ],
      [
        0.91,
        0.78,
        -2.02
      ],
      [
        -0.91,
        0.78,
        -2.02
      ],
      [
        0.86,
        0.95,
        1.1
      ],
      [
        -0.86,
        0.95,
        1.1
      ],
      [
        0.7,
        1.4,
        0.35
      ],
      [
        -0.7,
        1.4,
        0.35
      ],
      [
        0.7,
        1.42,
        -1.25
      ],
      [
        -0.7,
        1.42,
        -1.25
      ],
      [
        0.82,
        1.05,
        -1.95
      ],
      [
        -0.82,
        1.05,
        -1.95
      ],
      [
        0.7,
        0.22,
        1.6
      ],
      [
        -0.7,
        0.22,
        1.6
      ],
      [
        0.7,
        0.24,
        -1.55
      ],
      [
        -0.7,
        0.24,
        -1.55
      ]
    ],
    "dragArea": 0.85,
    "liftAreaFront": -0.14,
    "liftAreaRear": -0.16,
    "rollCenterHeight": 0.12
  },
  "wheels": [
    {
      "position": [
        0.8,
        0.263,
        1.28
      ],
      "axle": "front",
      "side": "left"
    },
    {
      "position": [
        -0.8,
        0.263,
        1.28
      ],
      "axle": "front",
      "side": "right"
    },
    {
      "position": [
        0.8,
        0.263,
        -1.28
      ],
      "axle": "rear",
      "side": "left"
    },
    {
      "position": [
        -0.8,
        0.263,
        -1.28
      ],
      "axle": "rear",
      "side": "right"
    }
  ],
  "tyre": {
    "compound": "tarmac",
    "radius": 0.32,
    "width": 0.235,
    "inertia": 1.35,
    "relaxationLong": 0.18,
    "relaxationLat": 0.3,
    "loadSensitivity": 0.1,
    "nominalLoad": 3400,
    "lateralGripRatio": 0.96,
    "surfaceGrip": {
      "tarmac": 1.19,
      "concrete": 1.19,
      "gravel": 0.85,
      "loose": 0.8,
      "mud": 0.8,
      "wet": 0.85,
      "grass": 0.85
    },
    "surfaceSlip": {
      "tarmac": 0.85,
      "concrete": 0.85
    }
  },
  "suspension": {
    "front": {
      "travel": 0.165,
      "springRate": 68000,
      "preload": 0,
      "bumpDamping": 6200,
      "reboundDamping": 8500,
      "dampingKnee": 0.25,
      "highSpeedFactor": 0.45,
      "bumpStopLength": 0.03,
      "bumpStopRate": 260000,
      "antiRollRate": 10000
    },
    "rear": {
      "travel": 0.165,
      "springRate": 52000,
      "preload": 0,
      "bumpDamping": 5000,
      "reboundDamping": 7000,
      "dampingKnee": 0.25,
      "highSpeedFactor": 0.45,
      "bumpStopLength": 0.03,
      "bumpStopRate": 220000,
      "antiRollRate": 20000
    }
  },
  "steering": {
    "maxAngleDeg": 30,
    "ratio": 12,
    "ackermann": 0.5
  },
  "engine": {
    "idleRpm": 1100,
    "limiterRpm": 7500,
    "torqueCurve": [
      [
        0,
        120
      ],
      [
        1000,
        160
      ],
      [
        1500,
        200
      ],
      [
        2500,
        330
      ],
      [
        3000,
        400
      ],
      [
        3500,
        430
      ],
      [
        4750,
        430
      ],
      [
        5000,
        410
      ],
      [
        5500,
        370
      ],
      [
        6000,
        335
      ],
      [
        6500,
        300
      ],
      [
        7000,
        270
      ],
      [
        7500,
        245
      ],
      [
        8000,
        200
      ]
    ],
    "naTorqueFraction": 0.42,
    "inertia": 0.12,
    "frictionTorque": [
      12,
      4
    ],
    "engineBrakeTorque": 55,
    "turbo": {
      "spoolUpTime": 0.45,
      "spoolDownTime": 0.3,
      "boostStartRpm": 1800,
      "boostFullRpm": 3400,
      "antiLagBoost": 0.7,
      "antiLagMinRpm": 3000
    }
  },
  "gearbox": {
    "ratios": [
      2.9,
      2.13,
      1.67,
      1.345,
      1.11
    ],
    "reverse": 3,
    "finalDrive": 3.9,
    "shiftTime": 0.06,
    "efficiency": 0.9,
    "autoUpRpm": 7150,
    "autoDownRpm": 3900
  },
  "clutch": {
    "maxTorque": 900,
    "engageRpm": 1300,
    "fullRpm": 2100,
    "launchRpm": 4200
  },
  "diffs": {
    "front": {
      "preload": 20,
      "powerRamp": 0.2,
      "coastRamp": 0.15
    },
    "rear": {
      "preload": 30,
      "powerRamp": 0.3,
      "coastRamp": 0.25
    }
  },
  "brakes": {
    "maxTorque": 7000,
    "frontBias": 0.6,
    "handbrakeTorque": 3200
  },
  "hidden": true
}
